import { createFileRoute } from "@tanstack/react-router";
import Kiosk from "@/pages/Kiosk";

export const Route = createFileRoute("/kiosk")({
  component: Kiosk,
});
